import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Loading, PageHeader, ProjectToolNav} from "~/components";
import {useCan} from "~/hooks";
import {useGetGscConnectionQuery} from "~/reduxs/api/gscApiSlice";
import GscConnect from "../components/GscConnect";
import GscPropertyPicker from "../components/GscPropertyPicker";
import GscReports from "../components/GscReports";

/**
 * Trang tool Google Search Console của một dự án (`/projects/:id/gsc`).
 *
 * Điều hướng theo trạng thái kết nối:
 *  - chưa kết nối / revoked → GscConnect (nút kết nối OAuth).
 *  - property_pending       → GscPropertyPicker (chọn property).
 *  - connected + property   → GscReports (tổng quan + top query/page). Poll khi còn backfill.
 */
function GscHome() {

	const {id} = useParams();
	const canGsc = useCan('gsc');

	const [poll, setPoll] = useState(0);
	const {data: conn, isLoading} = useGetGscConnectionQuery(id, {
		pollingInterval: poll,
		skipPollingIfUnfocused: true,
	});

	// Đang backfill (đã connected nhưng chưa kéo xong 16 tháng) → poll để cập nhật tiến độ.
	const syncing = conn?.connected && conn?.status === 'connected' && conn?.backfill_done === false;

	useEffect(() => {
		setPoll(syncing ? 15000 : 0);
	}, [syncing]);

	if (!canGsc) return <div className="container">Bạn không có quyền sử dụng Google Search Console.</div>;
	if (isLoading) return <Loading />;

	const status = conn?.connected ? conn.status : 'none';

	return (
		<div className="container">
			<ProjectToolNav projectId={id} active="gsc" />

			<PageHeader
				icon="fa-light fa-magnifying-glass-chart"
				title="Google Search Console"
				subtitle={conn?.property_url || 'Dữ liệu hiệu suất tìm kiếm thật từ Google'}
			/>

			{(status === 'none' || status === 'revoked') && (
				<GscConnect projectId={id} revoked={status === 'revoked'} email={conn?.email} />
			)}

			{status === 'property_pending' && (
				<GscPropertyPicker projectId={id} email={conn?.email} />
			)}

			{status === 'connected' && conn?.property_url && (
				<GscReports projectId={id} connection={conn} />
			)}
		</div>
	);
}

export default GscHome;
